/**
 * Default quickshop options
 *
 * @see launchQuickshopUtils.js for options
 */
export const productQuickshopOptions = {
    ownerView: false,
    shopperView: false,
    wrapPagination: false,
    showAddToWishlist: true,
    showAddToFavorites: true,
    showAddToRegistry: true,
    collapseAccordions: true,
    hideSizeGuide: true,
    hideRequestSwatch: true
};
